/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CopilotFeatureMetric extends models.CopilotMetricActivityBase {
    getFixupPrototypeFunction() { return CopilotFeatureMetric.fixupPrototype; }

    static newInstance(model: Partial<CopilotFeatureMetric>): CopilotFeatureMetric {
        let obj = Object.assign(new CopilotFeatureMetric(), model);
        CopilotFeatureMetric.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CopilotFeatureMetric>): CopilotFeatureMetric {
        if (!model) return null;
        return CopilotFeatureMetric.newInstance(<CopilotFeatureMetric> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CopilotFeatureMetric) {
        if (!obj) return;

        models.CopilotFeatureMetric.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CopilotFeatureMetric): boolean {
        if (models.CopilotMetricActivityBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CopilotFeatureMetric.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Feature name (e.g. code_completion, agent_edit)
     */
    name: string;

}
